import { http } from 'http';

export default {
  deleteDocument: ({ folder, fileName }) =>
    http.delete(`/actas/devolucion/docs/${folder}/${fileName}`)
};
